import setCookies from "./sales-force-cookie";

const metaFlagName = "site.salesforceMarketingCloudEnabled";

export function exec() {
    const metaFlag = document.querySelector(`meta[name="${metaFlagName}"]`);

    if (metaFlag && metaFlag.getAttribute("content") === "true") {
        setCookies();
    }
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sales-force-cookie/index.js